/**
 * Renata Mini PWA — Chat screen at /renata/
 */
import { createFileRoute } from "@tanstack/react-router";
import { useWorkspaceTenantId } from "@/hooks/use-workspace-tenant-id";
import { RenataPanel } from "@/components/renata/RenataPanel";
import { useLocation } from "@tanstack/react-router";
import { clientRequestHeaders } from "@/lib/sm-api";
import { useEffect } from "react";

export const Route = createFileRoute("/renata/")({
  component: RenataMiniChat,
  head: () => ({ meta: [{ title: "Renata — Chat" }] }),
});

function RenataMiniChat() {
  const tenantId = useWorkspaceTenantId();
  const location = useLocation();

  useEffect(() => {
    if (!tenantId) return;
    void fetch("/api/renata/channel-events", {
      method: "POST",
      credentials: "include",
      headers: {
        ...clientRequestHeaders(tenantId),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ eventType: "mini_pwa_opened" }),
    }).catch(() => {});
  }, [tenantId]);

  if (!tenantId) return null;

  return (
    <div className="h-full min-h-0 overflow-hidden">
      <RenataPanel
        tenantId={tenantId}
        currentRoute={location.pathname}
        compact={false}
      />
    </div>
  );
}
